var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "358.000000pt",
    height: "241.000000pt",
    viewBox: "0 0 358.000000 241.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\r\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,241.000000) scale(0.100000,-0.100000)",
    fill: "red",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M994 1861 c-49 -22 -80 -60 -95 -114 -7 -25 -9 -129 -7 -281 3 -227 4 -244 26 -291 18 -39 83 -110 285 -312 296 -296 326 -317 442 -316 108 1 139 22 348 231 206 207 229 241 230 341 0 31 -8 81 -18 111 -16 51 -38 75 -294 331 -171 171 -291 283 -316 295 -36 17 -67 19 -300 22 -237 2 -264 1 -301 -17z m784 -403 c139 -139 260 -265 268 -280 22 -41 17 -81 -15 -124 -15 -21 -96 -105 -178 -186 -160 -157 -189 -174 -252 -149 -15 7 -143 128 -285 270 l-256 258 0 231 0 232 232 0 232 0 254 -252z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288 1524 c-60 -32 -78 -129 -33 -183 34 -39 85 -56 127 -42 101 35 125 149 47 216 -35 29 -97 33 -141 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2025 1868 c-32 -18 -44 -40 -45 -78 0 -32 20 -55 285 -320 298 -298 307 -310 290 -377 -4 -17 -81 -102 -204 -228 -109 -110 -201 -208 -204 -217 -19 -53 52 -120 105 -99 13 5 114 101 225 213 229 230 247 257 246 368 0 116 -12 131 -321 442 -152 154 -289 286 -304 294 -32 17 -46 17 -73 2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHold);
export default __webpack_public_path__ + "static/media/hold.56e6b077d5d9154d16792983023cb471.svg";
export { ForwardRef as ReactComponent };